import { render, staticRenderFns } from "./CashierTransfer.vue?vue&type=template&id=6652283e&scoped=true"
import script from "./CashierTransfer.vue?vue&type=script&lang=js"
export * from "./CashierTransfer.vue?vue&type=script&lang=js"
import style0 from "./CashierTransfer.vue?vue&type=style&index=0&id=6652283e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6652283e",
  null
  
)

export default component.exports